<template>
    <b-row>
        <b-col cols="12">
            <TitleComponent title="3. Finalizar compra" subtitle="- Selecciona un método de pago y avanza al último paso antes de finalizar la compra" />
        </b-col>
        <b-col cols="12">
            <ValidationObserver tag="form" ref="paso3" @submit.prevent="terminar()">
                <b-row>
                    <b-col cols="12" v-if="metodos_pago">
                        <div class="form-group">
                            <label for="metodo_pago">Método de pago</label>
                            <ValidationProvider name="método de pago" rules="required" v-slot="{ errors }">
                                <multiselect
                                    id="metodo_pago"
                                    v-model="datos_compra.metodo_pago"
                                    placeholder="Método de pago"
                                    trackBy="id"
                                    label="nombre"
                                    :disabled="disabled"
                                    :options="metodos_pago"
                                />
                                <span v-if="errors[0]" class="d-block invalid-feedback text-xs bg-danger white h7 mb-4 p-2 font-weight-bold">
                                    {{ errors[0] }}
                                </span>
                            </ValidationProvider>
                        </div>
                        <template v-if="datos_compra.metodo_pago != null && datos_compra.metodo_pago.valor == 9">
                            <FormInput label="IBAN" name="IBAN" rules="required" v-model="datos_compra.iban" :disabled="disabled" />
                            <FormInput label="Titular de la cuenta" name="Titular de la cuenta" rules="required" v-model="datos_compra.titular_cuenta" :disabled="disabled" />
                        </template>
                    </b-col>
                    <b-col cols="12">
                        <Button id="continuar-paso4" type="submit" class="btn-block" :disabled="disabled">
                            CONTINUAR COMPRA
                        </Button>
                    </b-col>
                </b-row>
            </ValidationObserver>
        </b-col>
    </b-row>
</template>

<script>
    import TitleComponent from '@/components/backend/stepper/components/TitleComponent';

    export default {
        props: {
            datos_compradores: {
                type: Array,
                required: true
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                datos_compra: {
                    concepto: '',
                    metodo_pago: null,
                    modalidad: 0,
                    tipo: false
                }
            }
        },
        methods: {
            async terminar() {
                const isValid = await this.$refs.paso3.validate();
                if (!isValid) return;

                this.$emit('terminado', this.datos_compra);
            },
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            },
            metodos_pago() {
                return this.teatro.metodos_pago_abonos_bases.slice().filter(metodo_pago => metodo_pago.show_taquilla);
            }
        },
        components: {
            TitleComponent
        }
    }
</script>